import React from 'react'
import styled from 'styled-components'
import { AdminHeader } from './adminHeader'
import { Block } from '@mote/ui'

export const AdminLayout = ({ children }) => {
  return (
    <Root>
      <AdminHeader />
      <Block>{children}</Block>
    </Root>
  )
}

const Root = styled.div`
  padding: 40px 0;
  height: 100%;

  @media (max-width: 991px) {
    padding: 20px 0;
  }

  @media (max-width: 639px) {
    padding: 10px 0;
  }
`
